import e from "react";
import { Checkbox as _ } from "./index15.mjs";
import a from "./index16.mjs";
const i = `${I18n.t(
  "booking_engine.payment.refund_and_cancellation_policy"
)} ${I18n.t("booking_engine.payment.and_the_policy")} ${I18n.t(
  "booking_engine.payment.terms_and_conditions"
)}`, l = ({ onClick: n }) => /* @__PURE__ */ e.createElement(
  "span",
  {
    "data-testid": "tos-link",
    className: a["terms-and-conditions"],
    onClick: n
  },
  i
), s = ({
  showSalesTerms: n,
  showTermsAndConditions: t
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
  "span",
  {
    "data-testid": "sales-terms-span",
    className: a["terms-and-conditions"],
    onClick: () => {
      n && n();
    }
  },
  I18n.t("booking_engine.payment.refund_and_cancellation_policy")
), " ", I18n.t("booking_engine.payment.and_the_policy"), " ", /* @__PURE__ */ e.createElement(
  "span",
  {
    "data-testid": "tcn-span",
    className: a["terms-and-conditions"],
    role: "link",
    tabIndex: 0,
    onKeyDown: (c) => {
      c.key === "Enter" && t && t();
    },
    onClick: () => {
      t && t();
    }
  },
  I18n.t("booking_engine.payment.terms_and_conditions")
)), k = ({
  showSalesTerms: n,
  showTermsAndConditions: t
}) => t && n ? /* @__PURE__ */ e.createElement(
  s,
  {
    showSalesTerms: n,
    showTermsAndConditions: t
  }
) : t ? /* @__PURE__ */ e.createElement(l, { onClick: t }) : n ? /* @__PURE__ */ e.createElement(l, { onClick: n }) : /* @__PURE__ */ e.createElement("span", null, i), b = ({
  tncAccepted: n,
  setTncAccepted: t,
  showSalesTerms: c,
  showTermsAndConditions: o
}) => /* @__PURE__ */ e.createElement("div", { className: a["tnc-checkbox-container"] }, /* @__PURE__ */ e.createElement(
  _,
  {
    id: "tnc-checkbox",
    value: n,
    onChange: (r, m) => {
      m.preventDefault(), t(r);
    },
    "data-testid": "tnc-checkbox"
  }
), /* @__PURE__ */ e.createElement("label", { className: a["tnc-label"], htmlFor: "tnc-checkbox" }, I18n.t("booking_engine.payment.i_agree"), " ", /* @__PURE__ */ e.createElement(
  k,
  {
    showSalesTerms: c,
    showTermsAndConditions: o
  }
)));
export {
  b as TosElement,
  b as default
};
